
import React from 'react';
import { Form } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import DatePickerField from './form/DatePickerField';
import DestinationField from './form/DestinationField';
import FormSection from './form/FormSection';
import { useTripForm } from './form/useTripForm';

interface TripFormProps {
  className?: string;
}

const TripForm: React.FC<TripFormProps> = ({ className }) => {
  const { form, onSubmit } = useTripForm();

  return (
    <div className="bg-gradient-light rounded-lg shadow-md p-6 border border-purple-light">
      <h3 className="text-xl font-semibold mb-6 text-purple-tertiary">Trip Details</h3>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
          <FormSection 
            form={form} 
            name="name" 
            label="Trip Name"
          >
            <Input placeholder="Summer Vacation 2024" className="border-purple-light focus-visible:ring-purple-DEFAULT" />
          </FormSection>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <DatePickerField
              form={form}
              name="startDate"
              label="Start Date"
              disablePastDates={true}
            />

            <DatePickerField
              form={form}
              name="endDate"
              label="End Date"
              minDate={form.getValues("startDate")}
            />
          </div>

          <DestinationField form={form} />

          <FormSection 
            form={form} 
            name="description" 
            label="Description (Optional)"
          >
            <Textarea 
              placeholder="Add details about your trip..." 
              className="resize-none min-h-[100px] border-purple-light focus-visible:ring-purple-DEFAULT"
            />
          </FormSection>

          <Button 
            type="submit" 
            className="w-full bg-bright-purple hover:bg-bright-purple/90 shadow-md transform hover:translate-y-[-2px] transition-all duration-200"
            disabled={form.formState.isSubmitting}
          >
            {form.formState.isSubmitting ? "Creating Trip..." : "Create Trip"}
          </Button>
        </form>
      </Form>
    </div>
  );
};

export default TripForm;
